/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubmissionEvaluation } from './oralExamSubmissionEvaluation';

export type SubmissionOralExamEvaluation = OralExamSubmissionEvaluation | null;
